module.exports = __webpack_public_path__ + "media/humons.60f0404a.mp4";